<template>
	<ul v-if="teams.length" class="tournament-team-list">
		<li v-for="team in teams" :key="team.id">
			{{ team.name }} (Captain {{ team.captain.name | capitalize }})
		</li>
	</ul>
	<p v-else>No teams have signed up yet.</p>
</template>

<script>
	export default {
		name: "TournamentTeamList",
		props: {
			teams: {
				type: Array,
				required: true
			}
		}
	}
</script>

<style lang="scss">
	ul.tournament-team-list {
		list-style-type: none;
	}
</style>